import React from "react";
// import ReactPlayer from "react-player";
import { FaPlay } from "react-icons/fa";
import { generatePostVideoUrl } from "utility/index";
import { Orientation } from "utility/constants";
import dynamic from "next/dynamic";
import { useVideoPlayerStore } from "@hooks/useVideoControls";

const ReactPlayer = dynamic(() => import("react-player/lazy"), { ssr: false });

export default function VideoPost({ post }) {
  const postUrl = generatePostVideoUrl({ post });
  const muted = useVideoPlayerStore((state) => state.muted);
  const playing = useVideoPlayerStore((state) => state.playing);
  const play = useVideoPlayerStore((state) => state.play);

  const isVideoPortrait =
    post.contentOrientation === Orientation.PORTRAIT ||
    post.contentOrientation === Orientation.PORTRAIT_UPSIDE_DOWN;

  return (
    <div className="h-full max-h-full w-screen lg:w-full relative overflow-x-hidden justify-center flex">
      {isVideoPortrait ? (
        <div className="h-screen w-full min-w-[600px] max-w-full flex justify-center">
          <ReactPlayer
            className=" w-screen "
            height="100%"
            width="100%"
            url={postUrl}
            playing={playing}
            playsinline
            controls={false}
            muted={muted}
            loop
            style={{ width: "100%", objectFit: "cover" }}
          />
        </div>
      ) : (
        <div className="react-player h-screen w-screen min-w-[600px]min-h-screen">
          <ReactPlayer
            className=""
            height="100%"
            width="100%"
            url={postUrl}
            playing={playing}
            playsinline
            controls={false}
            muted={muted}
            loop
          />
        </div>
      )}

      {playing ? null : (
        <FaPlay
          className="text-5xl absolute top-1/2 left-1/2 text-white cursor-pointer"
          onClick={() => play()}
          aria-hidden
        />
      )}
    </div>
  );
}
